export const themes = ({
  color = 'white',
  colorBorder = 'lightGrey',
  orientation = 'top',
} = {}) => ({
  default: {
    thRoot: 'flex ltr:flex-row rtl:flex-row-reverse relative',
    thInner: `bg-${color} border-${orientation === 'top' ? 't' : 'b'}-1 border-${colorBorder} -m${
      orientation === 'top' ? 'x' : ''
    }-1 overflow-hidden px-5 p${orientation === 'top' ? 't' : 'b'}-5 text-center whitespace-nowrap`,
  },
});
